export enum BlobType {
    WorkflowImage = 'WorkflowImage',
    ModuleImage = 'ModuleImage',
    ProfileImage = 'ProfileImage',
    HeaderImage = 'HeaderImage',
    TestFile = 'TestFile',
    EmbeddedImages = 'EmbeddedImages',
    UserFile = 'UserFile',
    UserVerificationDocument = 'UserVerificationDocument',
}
